/**
 * Color Constants
 *
 * Shared color definitions for categories and other UI elements.
 */

/**
 * Type for category color definition
 */
export interface CategoryColor {
  /** Display name for the color */
  name: string;
  /** Hex color value */
  value: string;
  /** CSS variable name (maps to theme colors) */
  cssVar: string;
}

/**
 * Predefined color palette for categories
 */
export const CATEGORY_COLORS: CategoryColor[] = [
  { name: 'Blue', value: '#3b82f6', cssVar: 'primary' },
  { name: 'Green', value: '#10b981', cssVar: 'success' },
  { name: 'Orange', value: '#f59e0b', cssVar: 'warning' },
  { name: 'Red', value: '#ef4444', cssVar: 'danger' },
  { name: 'Purple', value: '#8b5cf6', cssVar: 'secondary' },
  { name: 'Gray', value: '#6b7280', cssVar: 'default' }
];
